import createSvgIcon from '../Utils/CreateSvgIcon';

export const BodyColorRed = createSvgIcon(
  <circle cx="10" cy="10" fill="#E24529" r="10" transform="matrix(1 0 0 -1 2 22)" />,
  'BodyColorRed',
);
